import { Star } from "lucide-react";

export interface TestimonialCardProps {
  quote: string;
  name: string;
  source?: string;
  context?: string;
  rating?: number;
}

/** Single strong proof point — a 5-star review rendered as a quote card. */
export function TestimonialCard({
  quote,
  name,
  source = "Google review",
  context,
  rating = 5,
}: TestimonialCardProps) {
  return (
    <figure className="rounded-2xl border border-border border-l-4 border-l-accent bg-white p-6 shadow-[0_2px_8px_rgba(15,26,66,0.04)]">
      <div className="flex items-center gap-0.5" role="img" aria-label={`${rating} out of 5 stars`}>
        {Array.from({ length: rating }).map((_, i) => (
          <Star key={i} className="h-4 w-4 fill-accent text-accent" aria-hidden="true" />
        ))}
      </div>
      <blockquote className="mt-3 text-[17px] font-medium leading-relaxed text-primary">
        “{quote}”
      </blockquote>
      <figcaption className="mt-4 text-sm text-foreground/70">
        <span className="font-semibold text-foreground/85">— {name}</span>
        {source ? <>, {source}</> : null}
        {context ? <span className="block">({context})</span> : null}
      </figcaption>
    </figure>
  );
}
